module.exports = __webpack_public_path__ + "img/badge.5f4cd60c.png";